<div class="order-summary" fxLayout="column" fxLayoutAlign="start end">
    <div>Total Retail: ${{order.subTotal | number}}</div>
    <div>Discount: ${{(order | getDiscountByCartOrOrder) | number}}</div>
    <div>Shipping Fee: ${{order.shippingFee | number}}</div>
    <div>Order Total: ${{order.grandTotal | number}}</div>
</div>